var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-loading mb-3"},_vm._l((_vm.quantityLoading),function(loading,index){return _c('ExLoading',{key:index,staticClass:"rounded",attrs:{"width":"12.5rem","maxWidth":"12.5rem","height":"18.75rem","animationDuration":"1.3s"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }